import { restoreSection } from "../actions/DocumentActions/index";

import BaseCommand from "./baseCommand";
import { DOCUMENT_MODE } from "../constants/document";
import { DOCUMENTS } from "../constants";
import {
  emptyQuoteTablePlaceholder,
  googleSheetSpace,
} from "../utils/documentUtils";

const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

class DeleteComponentCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
  }

  execute() {
    const { sectionID, section } = this.componentData;

    let updatedSection = section;
    if (section) {
      if (
        section.type === DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE ||
        section.type === DOCUMENT_COMPONENT_TYPES.DEAL_TABLE
      ) {
        updatedSection = {
          ...emptyQuoteTablePlaceholder(),
          id: section.id,
          section_id: section.id,
          dealTableId: this.componentData.dealTableId,
        };
      } else if (section.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET) {
        updatedSection = {
          ...googleSheetSpace(),
          id: section.id,
          section_id: section.id,
          label: section.label,
        };
      }
    }

    this.componentData.deleteDocumentComponentAction(sectionID);
    if (this.componentData.isPdfDocument) {
      this.componentData.deleteDocumentComponentAction(sectionID);
      const data = this.componentData.signerData.find(
        item => item.component_id === sectionID,
      );
      const deleteSigner = [
        {
          component_id: data.component_id,
          ids: [data.signers[0].id],
        },
      ];
      this.componentData.deleteDocSignerSection(
        deleteSigner,
        this.componentData.docID,
      );
    } else if (updatedSection && !this.componentData.isPdfDocument) {
      this.componentData.updateSectionService(updatedSection).then(() => {
        this.componentData
          .deleteSectionService(this.componentData.docNo, updatedSection)
          .then(response => {
            if (Array.isArray(response) && response.length > 0) {
              this.componentData.updateComponentsDBRowColIndexesAction(
                response,
              );
            }
          })
          .catch(() => {
            this.componentData.addDocumentComponentAction(
              this.componentData.layout,
              section,
            );
          });
      });
    } else {
      this.componentData
        .deleteSectionService(this.componentData.docNo, updatedSection)
        .then(() => {})
        .catch(() => {
          this.componentData.addDocumentComponentAction(
            this.componentData.layout,
            section,
          );
        });
    }
  }

  undo() {
    const {
      section,
      headerFooterType,
      layout,
      mode,
      docNo,
      docID,
    } = this.componentData;

    // Scroll section into view when do Undo
    if (section) {
      this.scrollIntoView(section.id);
    }

    restoreSection(mode)(docNo || docID, section, layout);

    this.componentData.addDocumentComponentAction(
      layout,
      section,
      headerFooterType,
      true,
    );
    if (
      mode === DOCUMENT_MODE.DOCUMENT &&
      section.type === DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER
    ) {
      this.componentData.addDealTableTab();
    }
  }
}

export default DeleteComponentCommand;



// WEBPACK FOOTER //
// ./src/commands/deleteComponentCommand.js